export const menAndWomenGenderOptions = [
  { label: 'Women', value: 'F' },
  { label: 'Men', value: 'M' }
];

export const genderOptions = [...menAndWomenGenderOptions, { label: 'Both', value: 'B' }];
